var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 1C12.75 0.585786 12.4142 0.25 12 0.25C11.5858 0.25 11.25 0.585786 11.25 1V2C11.25 2.41421 11.5858 2.75 12 2.75C12.4142 2.75 12.75 2.41421 12.75 2V1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9295 11.9972C18.8651 12.4487 18.4591 12.7564 18.003 12.7562L5.99535 12.7504C5.53925 12.7502 5.13349 12.442 5.06953 11.9904C5.0237 11.6669 5 11.3362 5 11C5 7.13401 8.13401 4 12 4C15.866 4 19 7.13401 19 11C19 11.3385 18.976 11.6715 18.9295 11.9972Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 18.5C14.25 20.8472 16.1528 22.75 18.5 22.75C20.8472 22.75 22.75 20.8472 22.75 18.5C22.75 16.1528 20.8472 14.25 18.5 14.25H4C3.58579 14.25 3.25 14.5858 3.25 15C3.25 15.4142 3.58579 15.75 4 15.75H18.5C20.0188 15.75 21.25 16.9812 21.25 18.5C21.25 20.0188 20.0188 21.25 18.5 21.25C16.9812 21.25 15.75 20.0188 15.75 18.5V18C15.75 17.5858 15.4142 17.25 15 17.25C14.5858 17.25 14.25 17.5858 14.25 18V18.5Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 18C2.25 17.5858 2.58579 17.25 3 17.25H8.5C9.74264 17.25 10.75 18.2574 10.75 19.5C10.75 20.7426 9.74264 21.75 8.5 21.75H7C6.58579 21.75 6.25 21.4142 6.25 21C6.25 20.5858 6.58579 20.25 7 20.25H8.5C8.91421 20.25 9.25 19.9142 9.25 19.5C9.25 19.0858 8.91421 18.75 8.5 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.75C22.4142 11.75 22.75 11.4142 22.75 11C22.75 10.5858 22.4142 10.25 22 10.25H21C20.5858 10.25 20.25 10.5858 20.25 11C20.25 11.4142 20.5858 11.75 21 11.75H22Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11.75C3.41421 11.75 3.75 11.4142 3.75 11C3.75 10.5858 3.41421 10.25 3 10.25H2C1.58579 10.25 1.25 10.5858 1.25 11C1.25 11.4142 1.58579 11.75 2 11.75H3Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6014 3.39862C19.8943 3.69152 19.8943 4.16639 19.6014 4.45928L18.8943 5.16639C18.6014 5.45928 18.1265 5.45928 17.8336 5.16639C17.5407 4.8735 17.5407 4.39862 17.8336 4.10573L18.5407 3.39862C18.8336 3.10573 19.3085 3.10573 19.6014 3.39862Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39862 4.45928C4.10573 4.16639 4.10573 3.69152 4.39862 3.39862C4.69152 3.10573 5.16639 3.10573 5.45929 3.39862L6.16639 4.10573C6.45929 4.39862 6.45929 4.8735 6.16639 5.16639C5.8735 5.45928 5.39862 5.45928 5.10573 5.16639L4.39862 4.45928Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindSun);
export default __webpack_public_path__ + "static/media/wind-sun.da68f81764437ef29340fc07d462a8af.svg";
export { ForwardRef as ReactComponent };